import {VerticalDraggable} from '../VerticalDraggable';

const styles = require('!!raw-loader!./style.css').default;
const btnSvg = require('!!raw-loader!./button.svg').default;
const qrcodeBtnSvg = require('!!raw-loader!./qrcode-btn.svg').default;
const qrcodeEurekaSvg = require('!!raw-loader!./qrcode-eureka.svg').default;
export const componentName = 'ps-cs-btn';

export class PsCsBtnElement extends HTMLElement {
    // 组件的构造函数
    private state: { hasNewMessage: boolean };
    constructor() {
        super(); // 调用父类的constructor
        this.attachShadow({ mode: 'open' }); // 附加一个shadow DOM

        this.state = {
            hasNewMessage: false,
        };

        // 绑定事件处理器的上下文
        this.handleClick = this.handleClick.bind(this);
    }

    // 连接到DOM时调用，可以在这里绑定事件
    connectedCallback() {
        this.render();
        this.shadowRoot.addEventListener('click', this.handleClick);
        this.listenUnread()
        this.bindDrag(true)
    }

    // 从DOM中移除时调用，可以在这里解绑事件
    disconnectedCallback() {
        this.shadowRoot.removeEventListener('click', this.handleClick);
        this.bindDrag(false)
    }
    
    get namespace() {
        return this.getAttribute('namespace')
    }

    private verticalDraggable:VerticalDraggable = undefined
    private bindDrag(bol:boolean) {
        if(this.verticalDraggable) {
            this.verticalDraggable.destroy();
            this.verticalDraggable = undefined
        }
        if(bol) {
            this.verticalDraggable = new VerticalDraggable(this)
        }
    }

    private listenUnread() {
        const self = this;
        switch (this.namespace) {
        case 'ysf':
            window.ysf('onunread',  (result) => {
                const hasNewMessage = result.total > 0;
                if(hasNewMessage !== self.state.hasNewMessage) {
                    self.state.hasNewMessage = hasNewMessage;
                    self.render()
                }
            });
            break;
        }
    }

    // 处理点击事件
    handleClick(e) {
        if(this.verticalDraggable?.isReallyDragging) {
            return
        }
        this.state.hasNewMessage = false
        if(this.shadowRoot.querySelector('.ps-qrcode-btn')?.contains(e.target)){
            return
        }
        switch (this.namespace) {
        case 'ysf':
            window.ysf('open')
            break;
        }
        this.render(); // 重新渲染
    }

    // 渲染组件
    render() {
        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          cursor: pointer;
          position: fixed;
          right: 24px;
          bottom: 30px;
          border-radius: 38px;
          background: var(--brand-primary, #45a321);
        }
        ${styles}
      </style>
      <div class="ps-cs-widget">
        <div class="ps-qrcode-btn icon-box">
        ${qrcodeBtnSvg}
        <div class="ps-qrcode-eureka">
        ${qrcodeEurekaSvg}
        <div>扫码进入 Eureka小程序<br>你的随身技术知识库！</div>
        </div>
        </div>
        <div class="ps-qiyu-btn-wrap" data-has-noti="${this.state.hasNewMessage}">
            <div class="ps-qiyu-btn icon-box">${btnSvg}</div>
        </div>
      </div>
    `;
    }
}

export default function register() {

    if (!customElements.get(componentName)) {
        // 如果没有，注册自定义元素
        customElements.define(componentName, PsCsBtnElement);
    } else {
        // 如果已经注册，可以选择打印一条警告或者什么也不做
        console.warn(`${componentName} 已经被注册`);
    }

}
